<template>
    <form @submit.prevent="sendForm">
        <div class="container mb-4">
            <div class="k-panel k-panel--grid">
                <div class="k-panel__body k-panel__body--2-3 k-border-right">
                    <h3 class="k-h-tertiary k-mb-30">Základní údaje</h3>

                    <div class="k-form">
                        <div class="k-form__group">
                            <label class="k-form__label k-form__label--required">Název příspěvku</label>
                            <input class="k-form__input" type="text"  placeholder="Zadejte název příspěvku" v-model="form.title">
                            <field-error v-if="form_errors.title" >{{ form_errors.title[0] }}</field-error>
                        </div>

                        <div class="k-form__group">
                            <label class="k-form__label k-form__label--required">Definice problému</label>
                            <textarea class="k-form__textarea" placeholder="Zadejte popis příspěvku" v-model="form.content"></textarea>
                            <field-error v-if="form_errors.content" >{{ form_errors.content[0] }}</field-error>
                        </div>

                        <div class="mt-4">
                            <h3 class="k-h-tertiary">Přílohy</h3>

                            <drop-zone
                                    ref="dropzone"
                                    id="dropzone"
                                    class="k-dropzone"
                                    :options="dropZoneOptions"
                                    :include-styling="false"
                                    @vdropzone-complete="dropZoneFileCompleted"
                                    @vdropzone-success="dropZoneFileSuccess"
                                    @vdropzone-removed-file="dropZoneFileRemoved"
                            ></drop-zone>
                            <field-error v-if="form_errors.files" >{{ form_errors.files[0] }}</field-error>
                        </div>
                    </div>


                </div>

                <div class="k-panel__body k-panel__body--1-3 ">
                    <h3 class="k-h-tertiary k-mb-30">Parametry</h3>

                    <div class="k-form__group">
                        <label class="k-form__label k-form__label--required" for="choices-text-remove-button">Klíčová slova</label>
                        <input ref="keywords" class="form-control k-choices--multiple" id="choices-text-remove-button" type="text" placeholder="Klíčové slovo 1, Klíčové slovo 2,..." v-model="form.keywords" @change="keywordAdded">
                        <field-error v-if="form_errors.keywords" >{{ form_errors.keywords[0] }}</field-error>
                    </div>

                   <div class="k-form__group">
                        <label class="k-form__label k-form__label--required">Kategorie</label>
                        <select class="form-control k-choices--multiple" name="choices-multiple-remove-button" placeholder="This is a placeholder" multiple v-model="form.subcategories">
                            <option v-for="(value, index) in categoriesOptions" :value="index">{{ value }}</option>
                        </select>
                       <field-error v-if="form_errors.subcategories" >{{ form_errors.subcategories[0] }}</field-error>
                   </div>

                    <div class="k-form__group">
                        <div class="d-flex justify-content-between">
                            <label class="k-form__label k-form__label--required">Upozornění</label>
                            <a v-if="is_notify_all_btn_visible" @click="selectAllNotificationGroups" href="javascript:;">Vybrat všechny</a>
                        </div>
                        <select ref="notificationsInput" class="form-control k-choices--multiple" name="choices-multiple-remove-button" placeholder="This is a placeholder" multiple v-model.number="form.notifications">
                            <option v-for="(value, index) in notificationsOptions" :value="index">{{ value }}</option>
                        </select>
                        <field-error v-if="form_errors.notifications" >{{ form_errors.notifications[0] }}</field-error>
                    </div>

                    <div class="k-form__group">
                        <label class="k-form__label k-form__label--required">Status příspěvku</label>
                        <select class="form-control k-choices--multiple" name="choices-single-no-search" v-model="form.status_id">
                            <option placeholder value="">Vyberte status</option>
                            <option v-for="(value, index) in statuses" :value="index">{{ value }}</option>
                        </select>
                        <field-error v-if="form_errors.status_id" >{{ form_errors.status_id[0] }}</field-error>
                    </div>

                </div>

                <div class="k-panel__footer justify-content-between align-items-center">
                    <div class="k-panel__footer-btn">
                         <button class="k-btn k-btn--primary">
                            Uložit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import FormBase from '../FormBase.vue';
    import vueDropzone from "vue2-dropzone";
    import _ from 'lodash';

    export default {
        extends: FormBase,

        props: {
            fileUploadUrl: {
                type: String,
                required: true
            },
            categoriesOptions: {
                type: Object,
                required: true
            },
            statuses: {
                type: Object,
                required: true
            },
            notificationsOptions: {
                type: Object,
                required: true
            }
        },

        components: {
            'drop-zone': vueDropzone
        },

        data: function() {
            return ({
                form: {
                    title: '',
                    keywords: '',
                    content: '',
                    status_id: '',
                    notifications: [],
                    subcategories: [],
                    files: []
                },

                dropZoneOptions: {
                    url: this.fileUploadUrl,
                    previewTemplate: this.getDropZoneTemplate(),
                    chunkSize: 1000000,
                    chunking: true,
                    createImageThumbnails: false
                }
            });
        },

        computed: {
            // button for selecting all notification groups visibility
            is_notify_all_btn_visible: function() {
                return _.size(this.form.notifications) !== _.size(this.notificationsOptions);
            }
        },

        methods: {
            /**
             * Keyword added event handler
             *
             * @param change
             * @return void
             */
            keywordAdded: function(change) {
                this.form.keywords = change.target.value;
            },

            /**
             * Select all notification groups
             *
             * @return void
             */
            selectAllNotificationGroups: function() {
                let choices = this.getChoicesInstanceByElement(this.$refs.notificationsInput);
                _.forOwn(this.notificationsOptions, (value, key) => {
                    if (! _.includes(this.form.notifications, parseInt(key))) {
                        this.form.notifications.push(parseInt(key));
                        if (choices) {
                            choices.setChoiceByValue(key);
                        }
                    }
                });
            },

            /**
             * File was removed
             *
             * @param file
             * @return void
             */
            dropZoneFileRemoved: function(file) {
                // remove file from files list
                if (file.newName) {
                    _.remove(this.form.files, function(f) {
                        return f.newName === file.newName;
                    });
                }
            },
            /**
             * File was successfully uploaded handler
             *
             * @param file
             * @return void
             */
            dropZoneFileSuccess: function(file) {
                try {
                    let response = JSON.parse(file.xhr.response);
                    file.newName = response.newName;     // set new name for uploaded file

                    // push file into files list
                    this.form.files.push({
                        name: response.originalName,
                        newName: response.newName,
                        size: file.size
                    });

                } catch(e) {
                    this.flashImagesError();
                    this.$refs.dropzone.removeFile(file);
                    console.log(e);
                }
            },

            /**
             * Drop zone file upload completed handler
             *
             * @param file
             * @return void
             */
            dropZoneFileCompleted: function(file) {
                let previewElement = file.previewElement;

                // show content
                let previews = previewElement.getElementsByClassName('js-preview__item');
                _.each(previews, function(preview) {
                    if (! (preview.classList.contains('dz-remove') && file.status === "error")) {
                        preview.classList.add('js-preview__item--visible');
                    }
                });

                // handle error
                if (file.status === "error") {
                    previewElement.classList.add('js-preview--error');

                    // flash error
                    this.flashImagesError();

                    // remove element
                    setTimeout(() => {
                        this.$refs.dropzone.removeFile(file);
                    }, 2500);
                }
            },

            /**
             * Flash image error using debounce function to prevent multiple displays
             *
             * @return void
             */
            flashImagesError: _.debounce(function() {
                flash('Soubory se nepodařilo uložit.', 'danger');
            }, 500),

            /**
             * Send user form
             *
             * @return void
             */
            sendForm: async function () {
                let result = await this.sendData();
                if (result !== undefined && result.message.length) {
                    flash(result.message, result.success ? 'success' : 'danger');
                }
            },

            /**
             * Get dropzone template
             *
             * @return string
             */
            getDropZoneTemplate: () => {
                return `
                    <div class="dz-preview dz-file-preview js-preview">
                            <div class="k-file-meta mx-auto k-mr-20 js-preview__item">
                                <svg class="k-file-meta__icon" role="img" width="36" height="38">
                                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#file-pdf"></use>
                                        </svg>

                                <div class="k-file-meta__text" data-dz-size>

                                </div>
                        </div>
                        <div class="dz-remove js-preview__item" data-dz-remove><svg role="img" width="13" height="13" class=""><use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use></svg></div>
                        <div class="dz-filename js-preview__item"><span data-dz-name></span></div>
                        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    </div>`;
            }
        },

        mounted() {
            // append csrf token on submit
            let token = document.head.querySelector('meta[name="csrf-token"]').content;
            this.$refs.dropzone.dropzone.on('sending', function(file, xhr, formData) {
                formData.append("_token", token);
            });

            // append files into dropZone if present
            if (this.form.files.length > 0) {
                let newList = [];

                _.each(this.form.files, (file) => {
                    let fileToAppend = {
                        name: file.original_name,
                        newName: file.name,
                        size: file.size
                    };

                    this.$refs.dropzone.manuallyAddFile(fileToAppend);
                    newList.push(fileToAppend);
                });

                this.form.files = newList;
            }
        },

        created() {
            // transform notifications
            if (this.form.notifications.length > 0) {
                this.form.notifications = _.map(this.form.notifications, function(notification){
                    return notification.id;
                });
            }

            // transform categories
            if (this.form.subcategories.length > 0) {
                this.form.subcategories = _.map(this.form.subcategories, function(subcategory){
                    return subcategory.id;
                });
            }
        }
    }

</script>

<style>

    .js-preview {
        opacity: 1;
        transition: opacity 3.5s, border 2s;
    }

    .js-preview--error {
        border: 1px solid #d63031 !important;
        color: #d63031 !important;
        opacity: 0 !important;
    }

    .js-preview__item {
        opacity: 0;
        transition: opacity 2s;
    }

    .js-preview__item--visible {
        opacity: 1;
    }
</style>
